import { render, staticRenderFns } from "./infl-footnote.vue?vue&type=template&id=a4d97200&"
import script from "./infl-footnote.vue?vue&type=script&lang=js&"
export * from "./infl-footnote.vue?vue&type=script&lang=js&"
import style0 from "./infl-footnote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a4d97200', component.options)
    } else {
      api.reload('a4d97200', component.options)
    }
    module.hot.accept("./infl-footnote.vue?vue&type=template&id=a4d97200&", function () {
      api.rerender('a4d97200', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/infl-footnote.vue"
export default component.exports